/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './fetchLabels.defs.js'
export * as $defs from './fetchLabels.defs.js'
